/**
 * Enum representing status numbers for a quote throughout its lifecycle.
 */
export enum StatusNumber {
    QuoteInProgress = 1,
    Sent = 2,
    Declined = 3,
    Abandoned = 4,
    Indicated = 5,
    QuotePolicyCreated = 6,
    NotTakenUp = 10,
    SentModifiable = 11,
    NotRenewed = 12,
    Referred = 31,
    ReferralApproved = 32,
    ReferralApprovedModifiable = 33
}